import { create } from 'zustand';
import { sortBy } from 'lodash';
import axiosInstance from '@/plugins/axios';
import UtilsMask from '@/utils/UtilsMask';

export interface RootCnpjItem {
  value: string; // nrinsc (8 dígitos)
  title: string; // razão social
  subtitle: string; // cnpj mascarado
}

interface CompaniesState {
  rootCnpjs: RootCnpjItem[];
  loading: boolean;
  loaded: boolean;
  erro: string | null;
  fetchRootCnpjs: () => Promise<void>;
  reset: () => void;
}

let requestId = 0;

export const useCompaniesStore = create<CompaniesState>((set, get) => ({
  rootCnpjs: [],
  loading: false,
  loaded: false,
  erro: null,

  async fetchRootCnpjs() {
    if (get().loaded || get().loading) return;
    const request = ++requestId;
    set({ rootCnpjs: [], loading: true, loaded: false, erro: null });
    try {
      const { data } = await axiosInstance.get('agnes/companies');

      const mapped: RootCnpjItem[] = (data as any[]).map((c) => {
        const nrinsc = c.nrinsc || (c.cnpj ? String(c.cnpj).substring(0, 8) : '');
        return {
          value: nrinsc,
          title: c.razaoSocial || c.nomeFantasia || '',
          subtitle: UtilsMask.cnpj(c.cnpj || ''),
        };
      });
      if (request === requestId) set({ rootCnpjs: sortBy(mapped, ['title']), loaded: true });
    } catch (e) {
      if (request === requestId) {
        set({ erro: 'Não foi possível carregar empresas.' });
        console.error('Error fetching companies:', e);
      }
    } finally {
      if (request === requestId) set({ loading: false });
    }
  },
  reset() {
    requestId += 1;
    set({ rootCnpjs: [], loading: false, loaded: false, erro: null });
  },
}));
